// @core/api/endpoints/signature/create_signature.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateSignatureEvidenceRequest,
  SignatureResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * Create a signature evidence record
 * Persists an immutable signature evidence record. Usually invoked by internal/external provider adapters after crypto completion. End-users should go through the SubmitSignature flow (framework-ddw) which wraps this with provider dispatch and validation.
 */
export async function CreateSignature(
  data: CreateSignatureEvidenceRequest,
  options?: RequestOptions
): Promise<SignatureResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/signatures`;
  const requestOptions = options;
  return client.post<SignatureResponse>(requestPath, data, requestOptions);
}
